import lazysizes from 'lazysizes';
import 'lazysizes/plugins/noscript/ls.noscript';
import ComponentHelper from './components/00_utilities/helpers/ComponentHelper';
import LinkFocusHelper from './components/00_utilities/helpers/LinkFocusHelper';
import YoutubeHelper from './components/00_utilities/helpers/YoutubeHelper';
import ConsoleHelper from './components/00_utilities/helpers/ConsoleHelper';

const componentHelper = new ComponentHelper();

// Conditional import of container query polyfill if browser does not support containers
const supportsContainerQueries = 'container' in document.documentElement.style;
if (!supportsContainerQueries) {
    const loadContainerQueryPolyfill = async () => {
        await import('container-query-polyfill');
    };

    loadContainerQueryPolyfill().catch(console.error); // eslint-disable-line no-console
}

/* eslint-disable */
let svgFileName = '/Icons/icons.svg';
__webpack_public_path__ = 'http://localhost:8085/assets/';

if (!__devMode__) {
    svgFileName = `${__output__}Icons/icons.svg`;
    __webpack_public_path__ = `/${__output__}`;
}
const __svg__ = { path: './svg/*.svg', name: 'Icons/icons.svg', filename: svgFileName };
require('webpack-svgstore-plugin-fix-absolute-url/src/helpers/svgxhr')(__svg__);
/* eslint-enable */

window.addEventListener('load', () => {
    window.youtubePlayers = [];
    window.lazysizes = lazysizes;

    ConsoleHelper.printAgency();
    componentHelper.initializePage();
    LinkFocusHelper.handleHashLink();
    YoutubeHelper.addYoutubeConsentListener();
});

/**
 * Check for hot module replacement and use it if possible
 */
if (module.hot) {
    module.hot.accept();
}
